export default __webpack_public_path__ + "static/media/perk-heroic.5c334e6c.png";